import axiosInstance from "../../../helpers/api";

export const getAllSuperadminSections = (body) => {
  return axiosInstance.get("/superadmin/sections", body);
};

export const editSuperadminSections = (formData) => {
  return axiosInstance.post(
    `/superadmin/sections/${formData.id}`,
    formData.formData
  );
};

export const createSuperadminSections = (formData) => {
  return axiosInstance.post("/superadmin/sections", formData);
};

export const deleteSuperadminSection = (id) => {
  return axiosInstance.delete(`/superadmin/sections/${id}`);
};

export const getCourseSection = (id) => {
  return axiosInstance.get(`/superadmin/sections/courses/${id}`);
};
